// Module
var code = "<div id=\"estimate-detail\" flex layout=\"column\"> <cd-estimate-detail budget-estimate-lines=\"vm.budgetEstimate.lines\" product=\"vm.product\" product-version=\"vm.order.productVersion\"/> </div> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-product-estimate-detail.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;